var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { defaultProfessionalStatusData } from '../../../../backend/config/classifiers/defaults/DefaultProfessionalStatusData';
import { occupationGroupEntityName } from '../../../../backend/config/classifiers/entities/defineOccupationGroupClassifier';
export const getDefaultProfessionalStatusData = (context) => {
    const occupationGroupStorage = context.storage(occupationGroupEntityName);
    const occupationGroups = occupationGroupStorage.list({});
    const occupationGroupNameToIdMap = occupationGroups.rows.reduce((acc, { columns, id }) => {
        acc[columns.name] = id;
        return acc;
    }, {});
    return defaultProfessionalStatusData.map((defaultProfessionalStatus) => {
        const { occupationGroupNames } = defaultProfessionalStatus, professionalStatusData = __rest(defaultProfessionalStatus, ["occupationGroupNames"]);
        const occupationGroupIds = occupationGroupNames.flatMap((title) => {
            const id = occupationGroupNameToIdMap[title];
            return id ? id : [];
        });
        return Object.assign(Object.assign({}, professionalStatusData), { occupationGroupIds });
    });
};
